<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (emails.length) {
  <div class="profile:flex profile:flex-inline profile:flex-col profile:md:flex-row profile:flex-wrap profile:wrap-break-words">
    @for (email of emails; track email.emailId) {
      <div
        class="profile:grow profile:mb-fluid-md profile:min-w-60 profile:max-w-full profile:max-xs:min-w-[320px] profile:max-sm:not-last:me-static-lg profile:max-xs:first:mt-0"
      >
        @if (email.isPorscheId) {
          <profile-pds-p-icon p-icon name="lock" aria-hidden="true" color="contrast-medium"></profile-pds-p-icon>
          <profile-pds-p-text p-text size="inherit" class="profile:text-[14px] profile:inline-block" color="contrast-medium"
            >{{ translations.porscheIDLabel }}
          </profile-pds-p-text>
        }
        @if (email.isVerified && !email.isPorscheId) {
          <div class="profile:mb-fluid-sm">
            <profile-pds-p-tag p-tag variant="success-frosted" icon="check">{{ translations.verifiedLabel }}</profile-pds-p-tag>
          </div>
        }
        <div>
          <p data-protractor-id="saved-email" class="profile:text-[20px] profile:leading-[1.5]">{{ email.email }}</p>
        </div>
        <div class="profile:flex profile:flex-row profile:gap-x-static-md">
          <div>
            @if (email && email.isPorscheId && email.isStandard) {
              <div>
                <profile-pds-p-button-pure
                  [attr.id]="'goToChangePorscheIdPage-' + email.emailId"
                  p-button-pure
                  class="profile:py-static-sm"
                  (click)="goToChangePorscheIdPage()"
                  [myprofileUiTrack]="{
                    clickElementType: 'link',
                    clickElementId: 'email_address',
                    clickElementName: 'goto_change_porsche_id_link',
                  }"
                  >{{ translations.changePorscheIDLinkLabel }}
                </profile-pds-p-button-pure>
              </div>
            }
            @if (!isCnUser || (isCnUser && !restrictGlobalUIChanges)) {
              @if (!email.isStandard || !email.isVerified || (email.isPorscheId && !email.isStandard)) {
                <profile-pds-p-button-pure
                  p-button-pure
                  icon="edit"
                  (click)="enterEditMode(email)"
                  class="profile:py-fluid-sm"
                  [attr.id]="'email-edit-btn-' + email.emailId"
                  [aria]="{ 'aria-label': a11yLabelFor(translations.editButtonA11y, email) }"
                  [myprofileUiTrack]="{
                    clickElementType: 'button',
                    clickElementId: 'email_address',
                    clickElementName: 'edit',
                  }"
                >
                  {{ translations.editButtonLabel }}
                </profile-pds-p-button-pure>
              }
            }
          </div>
          <div>
            @if (!isCnUser || (isCnUser && !restrictGlobalUIChanges)) {
              @if (!email.isPorscheId) {
                <profile-pds-p-button-pure
                  p-button-pure
                  icon="delete"
                  class="profile:py-fluid-sm"
                  [attr.id]="'email-delete-btn-' + email.emailId"
                  [aria]="{ 'aria-label': a11yLabelFor(translations.deleteButtonA11y, email), 'aria-haspopup': 'dialog' }"
                  (click)="deleteItem(email)"
                  [myprofileUiTrack]="{
                    clickElementType: 'button',
                    clickElementId: 'email_address',
                    clickElementName: 'delete',
                  }"
                >
                  {{ translations.deleteButtonLabel }}
                </profile-pds-p-button-pure>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
}
